import { render, staticRenderFns } from "./TargetAndReward.vue?vue&type=template&id=7e0a691b&scoped=true&"
import script from "./TargetAndReward.vue?vue&type=script&lang=js&"
export * from "./TargetAndReward.vue?vue&type=script&lang=js&"
import style0 from "./TargetAndReward.vue?vue&type=style&index=0&id=7e0a691b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e0a691b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7e0a691b')) {
      api.createRecord('7e0a691b', component.options)
    } else {
      api.reload('7e0a691b', component.options)
    }
    module.hot.accept("./TargetAndReward.vue?vue&type=template&id=7e0a691b&scoped=true&", function () {
      api.rerender('7e0a691b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/progressbar/Team/components/TargetAndReward.vue"
export default component.exports